// extracted by mini-css-extract-plugin
export var banner = "banner-module--banner--229be";
export var container = "banner-module--container--4e0c9";
export var fullscreenBanner = "banner-module--fullscreenBanner--c6525";
export var fullscreenImage = "banner-module--fullscreenImage--b2b8e";
export var image = "banner-module--image--75459";
export var overlayTitle = "banner-module--overlayTitle--30faf";
export var title = "banner-module--title--b50c6";